<template>
  <div class="full-height">
    <home-header></home-header>
    <intro></intro>
    <menu-organization></menu-organization>
    <hot-offers></hot-offers>
    <home-footer></home-footer>
  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import config from '@/components/utils/Config'
  import Intro from '@/components/partials/IntroLarge'
  import HomeHeader from '@/components/home/Header'
  import HotOffers from '@/components/car/HotOffers'
  import HomeFooter from '@/components/home/Footer'
  import MenuOrganization from '@/components/home/MenuOrganization'
  import MenuMedia from '@/components/home/MenuMedia'

  Vue.use(VueAxios, axios)

  export default {
    components: {
      Intro,
      HomeHeader,
      HotOffers,
      HomeFooter,
      MenuOrganization,
      MenuMedia
    },
    created () {
      Vue.axios.get(config.urls.check_all)
      .then((response) => {
        this.$store.commit('updateAuth', response.data)
      })
    }
  }
</script>



// WEBPACK FOOTER //
// Home.vue?d6787dd2